import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./manutencao-programada.component.html')
})
export class ManutencaoProgramadaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/manutencao-programada.component.ts
 **/